import { PETICIONES, PARAMETRES, VALID_URLS, ACCESO_EXTERNAL, BASE_WEB_HREF, LS_LANG, DEFAULT_LANG, LINKS_EXTERNAL, DESHAB_EXTERNA, STORAGE } from './../../../../core/utils/constants';
import { Utils } from 'src/app/core/utils/utils';
import { Notices } from 'src/app/core/entities/notices.model';
import { RolsExternal } from 'src/app/core/entities/rolsexternal.model';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { RolsExternalService } from 'src/app/core/repositories/rolsexternal.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, catchError} from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AccesoExternalService {

  readonly REUS_AYUDA: String = LINKS_EXTERNAL.REUS_AYUDA;
  readonly REUS_AYUDA_CAS: String = LINKS_EXTERNAL.REUS_AYUDA_CAS;
  readonly REUS_GUIA: String = LINKS_EXTERNAL.REUS_REQUISITOS_GUIA;
  readonly REUS_GUIA_CAS: String = LINKS_EXTERNAL.REUS_REQUISITOS_GUIA_ES;
  readonly REUS_TUTORIAL: String = LINKS_EXTERNAL.REUS_TUTORIAL;
  readonly REUS_TUTORIAL_PROV_CA: String = LINKS_EXTERNAL.REUS_TUTORIAL_PROV_CA;
  readonly REUS_TUTORIAL_PROV_ES: String = LINKS_EXTERNAL.REUS_TUTORIAL_PROV_ES;
  readonly REUS_REQUISITOS_GUIA: String = LINKS_EXTERNAL.REUS_REQUISITOS_GUIA;
  readonly REUS_REQUISITOS_GUIA_ES: String = LINKS_EXTERNAL.REUS_REQUISITOS_GUIA_ES;

  /** 1: ciudadano, 2: pasarela, 3: proveedor */
  public type: number = ACCESO_EXTERNAL.ciudadano.type;
  public title: string = "";
  public content: string = "";
  public descripcion: string = "";
  public textButton: string = "";
  public textButonAoc: string = "";

  public urlValid: string = "";
  public urlWeb: string = "";
  public rol: string = "";
  public idioma : string = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
  public objeto : any;

  ayudaLang: String = "";
  requisitos: String = "";
  guiaLang: String = "";
  public url: { value: string } | null = null;

  notices: Notices = new Notices();
  rolexterno: RolsExternal = new RolsExternal();

  constructor(
    private repository: RepositoryService,
    private repositoryService: RepositoryService,
    private rolsExternalService: RolsExternalService,
    private router: Router
  ) { }

  public inicio(type: number) {

    this.urlWeb = BASE_WEB_HREF;
    this.gestionRedirecIdioma();

    this.type = Utils.noUndfAndNull(type) && type <= 3 && type >= 1 ? type : ACCESO_EXTERNAL.ciudadano.type;
    let object = this.type == 2 ? ACCESO_EXTERNAL.empresa : (this.type == 3 ? ACCESO_EXTERNAL.proveedor : ACCESO_EXTERNAL.ciudadano)
    this.title = object.title;
    this.content = object.content;
    this.descripcion = object.descripcion;
    this.textButton = object.textButton;
    this.textButonAoc = object.textButonAoc;
    this.rol = object.rol;
    this.objeto = object;

    //Busca el clientId activo y crea la url que nos dirige al login Valid y objeto para habilitar/deshabilitar carpeta
    return forkJoin({
          url: this.repository.doGet(PETICIONES.regtel_parametre.findByCodi + PARAMETRES.CLIENTID),
          notices: this.repositoryService.findByCode(PETICIONES.notices.findByCode, DESHAB_EXTERNA),
          rol: this.rolsExternalService.findByCode(this.rol)
      }).pipe(map(({ url, notices, rol }) => {
        this.url = _.cloneDeep(url);
        this.notices = _.cloneDeep(notices);
        this.rolexterno = rol as RolsExternal;
        this.crearUrl(object, url.value);
        return true;
      }),catchError(() => {
        switch(this.type){
          case 1: {
            this.router.navigate(['/external/passarela/acces']);
            break;
          }
          case 2: {
            this.router.navigate(['/external/empreses/acces']);
            break;
          }
          case 3: {
            this.router.navigate(['/external/proveidors/acces']);
            break;
          }
        }
        return of(false);
      }));
  }

  /**
  * @description
  * Se genera la URL para llamar al servicio de validación
  * @param object Objeto con los datos de las urls
  * @param clientId ClientId a enviar en la url
  */
  public crearUrl(object: any, clientId: string) {
    let url = VALID_URLS.LOGIN;
    let urlOk = "?path_ok=" + BASE_WEB_HREF + object.urlOK;
    let urlKo = "&path_ko=" + BASE_WEB_HREF + object.urlKO;
    let urlCancel = "&path_cancel=" + BASE_WEB_HREF + object.urlCancel;
    clientId = Utils.noUndfAndNull(clientId) ? "&client_id=" + clientId : "";
    let idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG; 
    if(idioma == 'es'){
      this.urlValid = url + urlOk + urlKo + urlCancel + "&idioma=esp" + clientId;
    }else{
      this.urlValid = url + urlOk + urlKo + urlCancel + clientId;
    }
    console.log(this.urlValid);
  }

  /**
  * @description
  * Gestión de idioma a enlaces externos
  */
  public gestionRedirecIdioma(){
    let lang = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
    if(lang === 'ca'){
      this.ayudaLang = this.REUS_AYUDA;
      this.guiaLang = this.REUS_GUIA;
      this.requisitos = this.REUS_REQUISITOS_GUIA;
    }else{
      this.ayudaLang = this.REUS_AYUDA_CAS;
      this.guiaLang = this.REUS_GUIA_CAS;
      this.requisitos = this.REUS_REQUISITOS_GUIA_ES;
    }
  }


  /**
  * @description
  * Redirigimos el videotutorial dependiendo de que carpeta seleccionaael usuario
  */
  public videoTutorial(): String{
    switch(this.type){
      case 1: {
        return this.REUS_TUTORIAL;
      }
      case 2: {
        return this.REUS_TUTORIAL;
      }
      case 3: {
        if(this.idioma != 'ca'){
          return this.REUS_TUTORIAL_PROV_ES;
        }else{
          return this.REUS_TUTORIAL_PROV_CA;
        }
      }
      default:
        return this.REUS_TUTORIAL;
    }
  }

}
